import module from 'fan/proyecto/module.js'
import template from './template.html'

export class FanProyectoConfiguracionAreasEliminarComponent {
  constructor(FanProyectoConfiguracionAreasAreaService) {
    this.FanProyectoConfiguracionAreasAreaService = FanProyectoConfiguracionAreasAreaService
    this.data = undefined
    this.onClose = undefined
    this.procesando = false
  }

  aceptar() {
    this.procesando = true

    this.FanProyectoConfiguracionAreasAreaService.delete(this.data.id_proyecto, this.data.id_area)
      .then(() => (this.onClose({$event: {data: this.data}})))
      .finally(() => (this.procesando = false))
  }

  cancelar() {
    this.onClose()
  }
}

module.component('fanProyectoConfigAreasEliminar', {
  controller: FanProyectoConfiguracionAreasEliminarComponent,
  template: template,
  bindings: {
    data: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/fan/proyecto/components/configuracion/areas/eliminar/component.js